import React, { Component, useEffect, useRef, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import moment from 'moment';
import PrintSO from '../SalesOrder/PrintSO';
import { getDelivery, getPO, getSO, getTransfer } from '../../Service/EStatementService';
import PrintPO from '../PurchaseOrder/PrintPO';
import PrintDelivery from '../Delivery/PrintDelivery';
import PrintTransfer from '../Transfer/PrintTransfer';
import PrintIPG from '../SalesOrder/PrintIPG';
import { Helmet } from "react-helmet";
import { getDealerNonPKP } from '../../Service/SalesService';


const EStatement = () => {

    const componentRef = useRef();
    const { modul, id_so } = useParams();
    const [userInfo, setUserInfo] = useState({});
    const pageStyle = "body {background: #f2f2f2;}";
    const [info, setInfo] = useState({
        legal: "",
        user_information: "",
        nama_customer: '',
        kode_customer: '',
        phone: '',
        email: '',
        address: '',
        total_before_discount_with_free: 0,
        delivery_date: moment().format('YYYY-MM-DD'),
        created_date: moment().format('YYYY-MM-DD'),
        detail: [],
        listppn: [],
        bank: [],
        total: 0,
        total_ppn: 0,
        total_pph: 0,
        total_dpp: 0,
        diskon_promo: 0,
        grand_total: 0,
        total_discount: 0,
        deduction: 0,
        pph_rate: 0,
        status_so: '',
        payment_verified: false,
        npwp: '',
    });
    const [state, setState] = useState({
        order_id: null,
        order_no: '',
        docnum: '',
        approved_date: null,
        total_payment: 0,
        deduction_amount: 0,
        created_by_name: '',
        ppn_selected: 11,

    });
    const [statePO, setStatePO] = useState({
        overlimit: false,
        piutang_plus_order: 0,
        limit_kredit: 0,
        order_id: '',
        order_no: '',
        so_number: '',
        npwp: [],
        address_code: [],
        pkp_amount: 0,
        listPromo: [],
        listNpwp: [],
        listNpwp_Ori: [],
        listAddress: [],
        listDiskon: [],
        listordertype: [],
        shipping_name: '',
        shipping_address: '',
        detail: [],
        deduction: 0,
        total: 0,
        total_dpp: 0,
        total_ppn: 0,
        total_discount: 0,
        kuota_default: 0,
        grand_total: 0,
        rekomendasi_pkp: 0,
        selectedRow: {},
        listFreeDiskon: [],
        appliedAdditionalDiscount: [],
        supplier: [],
        listppn: [],
    });
    const [stateDelivery, setStateDelivery] = useState({
        order_no: '',
        nama_customer: '',
        driver: '',
        vehicle: '',
        delivery_number: '',
        delivery_date: moment().format('YYYY-MM-DD'),
        detail: [],
        processing: false,
        locked: true,
        status: 'Open',
        shipping_address: '',
        shipping_country: '',
        shipping_city: '',
        shipping_phone: ''
    });
    const [stateInventory, setStatesInventory] = useState({
        created_date: '',
        products: [],
        docnum: '',
        from: '',
        fromWhsName: '',
        to: '',
        toWhsName: '',
        consignee: '',
        remark: '',
        toWarehouses: [],
        status: '',
        errors: {
            from: '',
            to: '',
            consignee: '',
            products: ''
        },
    });
    const [stateIPG, setStatesIPG] = useState({
        pg_status: '',
        Bank: '',
        Amount: 0,
        TypePayment: '',
        card_number: '',
        pg_status: '',
        pg_expiration_date: '',
        paid_at: '',
        payment_method: '',
        payment_channel: '',
    });
    useEffect(() => {
        switch (modul) {
            case 'salesorder':
                getSO(id_so).then(res => {
                    let total_disk = 0;
                    let _so = res.data;
                    //console.log(_so);
                    let sum_dpp = 0;
                    for (const key in _so.detailItem) {
                        let _subtotal = _so.detailItem[key].LineTotal == 0 ? 0 : (_so.detailItem[key].TotalBefDi * _so.detailItem[key].Qty);
                        let _net_disc = _so.detailItem[key].M_DISC_1 ? parseFloat(_so.detailItem[key].M_DISC_1) / 100 : 0;
                        let _disk2 = _so.detailItem[key].M_DISC_2_PRC ? parseFloat(_so.detailItem[key].M_DISC_2_PRC) / 100 : 0;
                        let _disk3 = _so.detailItem[key].M_DISC_3 ? parseFloat(_so.detailItem[key].M_DISC_3) / 100 : 0;
                        let _disk4 = _so.detailItem[key].M_DISC_4 ? parseFloat(_so.detailItem[key].M_DISC_4) / 100 : 0;
                        let _prcntdisc = 1 - (1 - _net_disc) * (1 - _disk2) * (1 - _disk3) * (1 - _disk4);
                        let _dpp = parseFloat(_so.detailItem[key].VatPrcnt == 0 ? (_subtotal - (_prcntdisc * _subtotal)) : (_subtotal - (_prcntdisc * _subtotal)) / (1 + _so.detailItem[key].VatPrcnt / 100));

                        sum_dpp += _dpp
                        total_disk += _prcntdisc * _subtotal
                    }

                    let arr_detail = [];
                    let urut = 0;
                    for (const key in _so.detailItem) {
                        let deduct = parseFloat(_so.DiscSum || 0);
                        let subtotal = (_so.detailItem[key].TotalBefDi * _so.detailItem[key].Qty);
                        let subtotal_2 = _so.detailItem[key].LineTotal == 0 ? 0 : (_so.detailItem[key].TotalBefDi * _so.detailItem[key].Qty);
                        let pph_selected = _so.detailItem[key].WtLiable;
                        let net_disc = _so.detailItem[key].M_DISC_1 ? parseFloat(_so.detailItem[key].M_DISC_1) / 100 : 0;
                        let net_disc_amt = (subtotal - (subtotal * net_disc));
                        let disk2 = _so.detailItem[key].M_DISC_2_PRC ? parseFloat(_so.detailItem[key].M_DISC_2_PRC) / 100 : 0;
                        let disk3 = _so.detailItem[key].M_DISC_3 ? parseFloat(_so.detailItem[key].M_DISC_3) / 100 : 0;
                        let disk4 = _so.detailItem[key].M_DISC_4 ? parseFloat(_so.detailItem[key].M_DISC_4) / 100 : 0;
                        let prcntdisc = 1 - (1 - net_disc) * (1 - disk2) * (1 - disk3) * (1 - disk4);
                        let disc_total = subtotal_2 * (parseFloat(prcntdisc) / 100);
                        let dpp = parseFloat(_so.detailItem[key].VatPrcnt == 0 ? (subtotal_2 - (prcntdisc * subtotal)) : (subtotal_2 - (prcntdisc * subtotal)) / (1 + _so.detailItem[key].VatPrcnt / 100));
                        let prcnt_bef = (deduct / sum_dpp) * 100;
                        let am_ppn = parseFloat(dpp * (_so.detailItem[key].VatPrcnt / 100)).toFixed(2);
                        let am_ppn_after_disc = am_ppn - (am_ppn * (prcnt_bef / 100));
                        let am_pph = dpp - (dpp * prcnt_bef / 100);

                        urut += _so.detailItem[key].LineTotal == 0 ? 0 : 1;

                        arr_detail.push({
                            urut,
                            itemname: _so.detailItem[key].Dscription,
                            itemno: _so.detailItem[key].ItemCode,
                            price: _so.detailItem[key].TotalBefDi,
                            qty: _so.detailItem[key].Qty,
                            type: _so.detailItem[key].TypeWhs,
                            paketid: _so.detailItem[key].M_KD_CMPG,
                            paket_name: _so.detailItem[key].M_KET_CMPG,
                            gudang: _so.detailItem[key].WHS,
                            free: (_so.detailItem[key].LineTotal == 0 ? 1 : 0),
                            id: _so.detailItem[key].id,
                            ppn: _so.detailItem[key].VatPrcnt,
                            delivery: _so.detailItem[key].Delivery,
                            pph: _so.detailItem[key].WtLiable,
                            amount_ppn: am_ppn_after_disc,
                            amount_pph: (pph_selected == 'y' ? (am_pph * (parseFloat(_so.Rate || 0) / 100)) : 0),
                            amount_dpp: dpp,
                            amount_discount: _so.detailItem[key].LineTotal == 0 ? 0 : (prcntdisc * subtotal),
                            net_disc: _so.detailItem[key].LineTotal == 0 ? 0 : parseFloat(_so.detailItem[key].M_DISC_1),
                            net_disc_amt,
                            disc_2: parseFloat(_so.detailItem[key].M_DISC_2),
                            disc_total: disc_total,
                            final_price: net_disc_amt - parseFloat(_so.detailItem[key].M_DISC_2),
                            M_TP_PENJ: _so.detailItem[key].M_TP_PENJ,
                            disc_prcnt: _so.detailItem[key].DiscPrcnt,
                            M_DISC_1: _so.detailItem[key].M_DISC_1,
                            total_bef_di: _so.detailItem[key].TotalBefDi,
                            M_DISC_2_PRC: _so.detailItem[key].M_DISC_2_PRC,
                            additional_address: _so.detailItem[key].additional_address,
                            additional_receiver: _so.detailItem[key].additional_receiver,
                            additional_city: _so.detailItem[key].additional_city,
                            additional_county: _so.detailItem[key].additional_county,
                            additional_phone: _so.detailItem[key].additional_phone,
                        });
                    }

                    let _bank = [];

                    if (_so.bankList && _so.bankList.length) {
                        _bank = _so.bankList.map(item => {
                            return {
                                label: item.BankCode,
                                value: item.BankCode,
                                rekening: item.Account
                            }
                        });
                    }


                    const hitungan = Calculate(arr_detail);
                    /*setUserInfo({...userInfo , 
                        BPLFrName :_so.branchInfo.BPLFrName,
                        Address: _so.branchInfo.Address,
                        phone: _so.branchInfo.phone
                    });*/
                    setState({
                        ...state,
                        detail: arr_detail,
                        order_no: res.data.DocNumSO,
                        created_by_name: res.data.created_by_name
                    });

                    const deduksi = hitungan.amount_ppn > 0 ? _so.DiscSum : _so.DiscSumExPpn;
                    const mhc_address = (res) => {
                        try {
                            return {
                                address: res.data.mhc_data.address ? res.data.mhc_data.address + ", " + res.data.mhc_data.city : res.data.mhc_data.city,
                                cardname: res.data.mhc_data.cardname
                            }
                        } catch (e) {
                            return {
                                address: '',
                                cardname: ''
                            }
                        }
                    };
                    setInfo({
                        ...info,
                        bpl_name: mhc_address.cardname,
                        mhc_address: mhc_address.address,
                        nama_customer: res.data.shipping_name,
                        email: res.data.shipping_email,
                        phone: res.data.shipping_phone,
                        address: res.data.shipping_address,
                        deduction: parseFloat(_so.DiscSum || 0),
                        detail: arr_detail,
                        bank: _bank,
                        legal: res.data.legal_stuff,
                        user_information: res.data.user_info,
                        delivery_date: res.data.DocDueDate,
                        created_date: res.data.created_date,
                        pph_rate: parseFloat(_so.Rate || 0),
                        total_before_discount_with_free: hitungan.subtotal,
                        total: hitungan.subtotal,
                        total_ppn: hitungan.amount_ppn,
                        total_pph: hitungan.amount_pph,
                        total_dpp: hitungan.amount_dpp,
                        total_discount: hitungan.amount_disc,
                        grand_total: hitungan.amount_dpp + hitungan.amount_ppn - parseFloat(deduksi || 0) - hitungan.amount_pph,
                        status_so: _so.Status,
                        payment_verified: _so.payment_verified,
                        npwp: _so.npwp || '',
                    });
                })
                break;
            case 'purchaseorder':
                getPO(id_so).then(res => {
                    let _po = res.data;
                    let arr_detail = [];
                    for (const key in _po.items) {
                        let subtotal = (_po.items[key].totalbefdi * _po.items[key].qty);
                        let net_disc = _po.items[key].m_disc_1 ? parseFloat(_po.items[key].m_disc_1) / 100 : 0;
                        let disc_total = subtotal * net_disc;
                        let campaign_disc = parseFloat(_po.items[key].m_disc_2) / 100;
                        let prcntdisc = net_disc + ((1 - net_disc) * campaign_disc);

                        arr_detail.push({
                            itemname: _po.items[key].dscription,
                            itemno: _po.items[key].itemcode,
                            price: _po.items[key].totalbefdi,
                            qty: _po.items[key].qty,
                            type: (_po.items[key].mi_kd_cmpg?.substring(0, 4) == 'PREO' ? "Indent" : "Ready"),
                            paketid: _po.items[key].mi_kd_cmpg,
                            paket_name: _po.items[key].mi_ket_cmpg,
                            gudang: _po.items[key].whs,
                            free: (_po.items[key].linetotal == 0 ? 1 : 0),
                            id: _po.items[key].id,
                            ppn: _po.items[key].vatprcnt,
                            mi_add_disc: _po.items[key].mi_add_disc,
                            mi_ket_add_disc: _po.items[key].mi_ket_add_disc,
                            item_seq_dm: _po.items[key].item_seq_dm,
                            m_disc_3: parseFloat(_po.items[key].m_disc_3),
                            disc_item: parseFloat(_po.items[key].m_disc_2),
                            net_disc: parseFloat(_po.items[key].m_disc_1 ? _po.items[key].m_disc_1 : 0),
                            subtotal: subtotal - disc_total,
                            linetotal: parseFloat(_po.items[key].linetotal),
                            amount_dpp: parseFloat(_po.items[key].dpp),
                            amount_ppn: parseFloat(_po.items[key].ppn),
                            amount_discount: prcntdisc * subtotal,
                            item_seq_dm_asal: _po.items[key].item_seq_dm_asal
                        });
                    }

                    const hitungan = CalculatePO(arr_detail);
                    let address = null;
                    let phone = null;

                    if (_po.dealer_data) {
                        address = _po.dealer_data[0].address ? _po.dealer_data[0].address + ", " + _po.dealer_data[0].city : _po.dealer_data[0].city;
                        phone = _po.dealer_data[0].phone;
                    }

                    setUserInfo({
                        ...userInfo,
                        BPLFrName: _po.branchInfo?.BPLFrName || _po.bplname,
                        Address: _po.branchInfo?.Address || address || "",
                        phone: _po.branchInfo?.phone || phone || "",

                    });
                    setStatePO({
                        ...statePO,
                        order_no: _po.docnumpo,
                        docduedate: _po.docduedate,
                        order_id: id_so,
                        detail: arr_detail,
                        grand_total: _po.doctotal,
                        deduction: _po.discsum,
                        total: hitungan.subtot,
                        total_dpp: hitungan.amount_dpp,
                        total_ppn: hitungan.amount_ppn,
                        total_discount: hitungan.amount_disc,
                        shipping_name: _po.shipping_name,
                        shipping_address: _po.shipping_address,
                    });
                })
                break;
            case 'delivery':
                getDelivery(id_so).then(res => {
                    let _delivery = res.data;
                    let arr_detail = [];
                    for (const key in _delivery.product_details) {
                        arr_detail.push({
                            line_num: _delivery.product_details[key].line_num,
                            itemname: _delivery.product_details[key].item_name,
                            itemno: _delivery.product_details[key].item_code,
                            order_qty: _delivery.product_details[key].order_qty,
                            open_qty_default: _delivery.product_details[key].open_qty,
                            open_qty: _delivery.product_details[key].current_qty,
                            show: _delivery.product_details[key].open_qty == 0 ? false : true
                        });
                    }

                    setUserInfo({
                        ...userInfo,
                        BPLFrName: _delivery.branchInfo.BPLFrName,
                        Address: _delivery.branchInfo.Address,
                        phone: _delivery.branchInfo.phone
                    });

                    setStateDelivery({
                        ...stateDelivery,
                        order_no: _delivery.order,
                        nama_customer: _delivery.customer,
                        status: _delivery.status,
                        delivery_number: _delivery.delivery_number,
                        driver: _delivery.driver,
                        vehicle: _delivery.vehicle,
                        order_type: _delivery.delivery_type,
                        delivery_date: _delivery.created_date == "-" ? moment().format('YYYY-MM-DD') : _delivery.created_date,
                        detail: arr_detail,
                        shipping_address: _delivery.shipping_address,
                        shipping_country: _delivery.shipping_country,
                        shipping_city: _delivery.shipping_city,
                        shipping_phone: _delivery.shipping_phone,
                    });
                })
                break;
            case 'inventory-receipt':
                getTransfer(id_so).then(res => {
                    let _inventory = res.data;
                    const _products = _inventory.line_items.map(e => ({
                        itemno: e.itemcode,
                        itemname: e.dscription,
                        qty: e.qty,
                    }));

                    setUserInfo({
                        ...userInfo,
                        BPLFrName: _inventory.branchInfo.BPLFrName,
                        Address: _inventory.branchInfo.Address,
                        phone: _inventory.branchInfo.phone
                    });

                    setStatesInventory({
                        ...stateInventory,
                        docnum: _inventory.docnum,
                        from: _inventory.fromwhscode,
                        fromWhsName: _inventory.fromwhsname,
                        to: _inventory.towhscode,
                        toWhsName: _inventory.towhsname,
                        consignee: _inventory.consignee,
                        products: _products,
                        created_date: _inventory.created_date,
                        status: _inventory.status,
                        remark: _inventory.remark
                    });
                })
                break;

            case 'ipg':
                Promise.all([
                    getDealerNonPKP(3),
                    getSO(id_so)
                ]).then(([dealerRes, soRes]) => {
                    let dealerNonPKPData = dealerRes.data.data;
                    let res = soRes;
                    let total_disk = 0;
                    let _so = res.data;
                    //console.log(_so);
                    let sum_dpp = 0;
                    for (const key in _so.detailItem) {
                        let _subtotal = _so.detailItem[key].LineTotal == 0 ? 0 : (_so.detailItem[key].TotalBefDi * _so.detailItem[key].Qty);
                        let _net_disc = _so.detailItem[key].M_DISC_1 ? parseFloat(_so.detailItem[key].M_DISC_1) / 100 : 0;
                        let _disk2 = _so.detailItem[key].M_DISC_2_PRC ? parseFloat(_so.detailItem[key].M_DISC_2_PRC) / 100 : 0;
                        let _disk3 = _so.detailItem[key].M_DISC_3 ? parseFloat(_so.detailItem[key].M_DISC_3) / 100 : 0;
                        let _disk4 = _so.detailItem[key].M_DISC_4 ? parseFloat(_so.detailItem[key].M_DISC_4) / 100 : 0;
                        let _prcntdisc = 1 - (1 - _net_disc) * (1 - _disk2) * (1 - _disk3) * (1 - _disk4);
                        let _dpp = parseFloat(_so.detailItem[key].VatPrcnt == 0 ? (_subtotal - (_prcntdisc * _subtotal)) : (_subtotal - (_prcntdisc * _subtotal)) / (1 + _so.detailItem[key].VatPrcnt / 100));

                        sum_dpp += _dpp
                        total_disk += _prcntdisc * _subtotal
                    }

                    let arr_detail = [];
                    let urut = 0;
                    for (const key in _so.detailItem) {
                        let deduct = parseFloat(_so.DiscSum || 0);
                        let subtotal = (_so.detailItem[key].TotalBefDi * _so.detailItem[key].Qty);
                        let subtotal_2 = _so.detailItem[key].LineTotal == 0 ? 0 : (_so.detailItem[key].TotalBefDi * _so.detailItem[key].Qty);
                        let pph_selected = _so.detailItem[key].WtLiable;
                        let net_disc = _so.detailItem[key].M_DISC_1 ? parseFloat(_so.detailItem[key].M_DISC_1) / 100 : 0;
                        let net_disc_amt = (subtotal - (subtotal * net_disc));
                        let disk2 = _so.detailItem[key].M_DISC_2_PRC ? parseFloat(_so.detailItem[key].M_DISC_2_PRC) / 100 : 0;
                        let disk3 = _so.detailItem[key].M_DISC_3 ? parseFloat(_so.detailItem[key].M_DISC_3) / 100 : 0;
                        let disk4 = _so.detailItem[key].M_DISC_4 ? parseFloat(_so.detailItem[key].M_DISC_4) / 100 : 0;
                        let prcntdisc = 1 - (1 - net_disc) * (1 - disk2) * (1 - disk3) * (1 - disk4);
                        let disc_total = subtotal_2 * (parseFloat(prcntdisc) / 100);
                        let dpp = parseFloat(_so.detailItem[key].VatPrcnt == 0 ? (subtotal_2 - (prcntdisc * subtotal)) : (subtotal_2 - (prcntdisc * subtotal)) / (1 + _so.detailItem[key].VatPrcnt / 100));
                        let prcnt_bef = (deduct / sum_dpp) * 100;
                        let am_ppn = parseFloat(dpp * (_so.detailItem[key].VatPrcnt / 100)).toFixed(2);
                        let am_ppn_after_disc = am_ppn - (am_ppn * (prcnt_bef / 100));
                        let am_pph = dpp - (dpp * prcnt_bef / 100);

                        urut += _so.detailItem[key].LineTotal == 0 ? 0 : 1;

                        arr_detail.push({
                            urut,
                            itemname: _so.detailItem[key].Dscription,
                            itemno: _so.detailItem[key].ItemCode,
                            price: _so.detailItem[key].TotalBefDi,
                            qty: _so.detailItem[key].Qty,
                            type: _so.detailItem[key].TypeWhs,
                            paketid: _so.detailItem[key].M_KD_CMPG,
                            paket_name: _so.detailItem[key].M_KET_CMPG,
                            gudang: _so.detailItem[key].WHS,
                            free: (_so.detailItem[key].LineTotal == 0 ? 1 : 0),
                            id: _so.detailItem[key].id,
                            ppn: _so.detailItem[key].VatPrcnt,
                            delivery: _so.detailItem[key].Delivery,
                            pph: _so.detailItem[key].WtLiable,
                            amount_ppn: am_ppn_after_disc,
                            amount_pph: (pph_selected == 'y' ? (am_pph * (parseFloat(_so.Rate || 0) / 100)) : 0),
                            amount_dpp: dpp,
                            amount_discount: _so.detailItem[key].LineTotal == 0 ? 0 : (prcntdisc * subtotal),
                            net_disc: _so.detailItem[key].LineTotal == 0 ? 0 : parseFloat(_so.detailItem[key].M_DISC_1),
                            net_disc_amt,
                            disc_2: parseFloat(_so.detailItem[key].M_DISC_2),
                            disc_total: disc_total,
                            final_price: net_disc_amt - parseFloat(_so.detailItem[key].M_DISC_2),
                            M_TP_PENJ: _so.detailItem[key].M_TP_PENJ,
                            disc_prcnt: _so.detailItem[key].DiscPrcnt,
                            M_DISC_1: _so.detailItem[key].M_DISC_1,
                            total_bef_di: _so.detailItem[key].TotalBefDi,
                            M_DISC_2_PRC: _so.detailItem[key].M_DISC_2_PRC,
                            additional_address: _so.detailItem[key].additional_address,
                            additional_receiver: _so.detailItem[key].additional_receiver,
                            additional_city: _so.detailItem[key].additional_city,
                            additional_county: _so.detailItem[key].additional_county,
                            additional_phone: _so.detailItem[key].additional_phone,
                        });
                    }

                    let _bank = [];

                    if (_so.bankList && _so.bankList.length) {
                        _bank = _so.bankList.map(item => {
                            return {
                                label: item.BankCode,
                                value: item.BankCode,
                                rekening: item.Account
                            }
                        });
                    }


                    const hitungan = Calculate(arr_detail);
                    /*setUserInfo({...userInfo , 
                        BPLFrName :_so.branchInfo.BPLFrName,
                        Address: _so.branchInfo.Address,
                        phone: _so.branchInfo.phone
                    });*/
                    setState({
                        ...state,
                        detail: arr_detail,
                        order_no: res.data.DocNumSO,
                        created_by_name: res.data.created_by_name
                    });

                    const deduksi = hitungan.amount_ppn > 0 ? _so.DiscSum : _so.DiscSumExPpn;
                    const mhc_address = (res) => {
                        try {
                            return {
                                address: res.data.mhc_data.address ? res.data.mhc_data.address + ", " + res.data.mhc_data.city : res.data.mhc_data.city,
                                cardname: res.data.mhc_data.cardname
                            }
                        } catch (e) {
                            return {
                                address: '',
                                cardname: ''
                            }
                        }
                    };
                    setInfo({
                        ...info,
                        bpl_name: mhc_address.cardname,
                        mhc_address: mhc_address.address,
                        nama_customer: res.data.shipping_name,
                        email: res.data.shipping_email,
                        phone: res.data.shipping_phone,
                        address: res.data.shipping_address,
                        deduction: parseFloat(_so.DiscSum || 0),
                        detail: arr_detail,
                        bank: _bank,
                        legal: res.data.legal_stuff,
                        user_information: res.data.user_info,
                        delivery_date: res.data.DocDueDate,
                        created_date: res.data.created_date,
                        pph_rate: parseFloat(_so.Rate || 0),
                        total_before_discount_with_free: hitungan.subtotal,
                        total: hitungan.subtotal,
                        total_ppn: hitungan.amount_ppn,
                        total_pph: hitungan.amount_pph,
                        total_dpp: hitungan.amount_dpp,
                        total_discount: hitungan.amount_disc,
                        //grand_total: hitungan.amount_dpp + hitungan.amount_ppn - parseFloat(deduksi || 0) - hitungan.amount_pph,
                        grand_total: _so.DocTotal,
                        status_so: _so.Status,
                        payment_verified: _so.payment_verified,
                        npwp: _so.npwp || '',
                        dealer_non_pkp: dealerNonPKPData
                    });
                    setStatesIPG({
                        ...stateIPG,
                        Bank: _so.payment[0]?.BANK,
                        Amount: _so.payment[0]?.Amount,
                        TypePayment: _so.payment[0]?.TypePayment,
                        card_number: _so.payment[0]?.card_number,
                        pg_status: _so.payment[0]?.pg_status,
                        pg_expiration_date: _so.payment[0]?.pg_expiration_date,
                        paid_at: _so.payment[0]?.paid_at,
                        payment_method: _so.payment[0]?.payment_method,
                        payment_channel: _so.payment[0]?.payment_channel,
                    });
                    console.log('dealer_non_pkp:', dealerNonPKPData);
                })
                break;

            default:
                break;
        }
    }, [])

    const Calculate = (details) => {
        let subtotal = 0;
        let amount_ppn = 0;
        let amount_pph = 0;
        let amount_dpp = 0;
        let amount_disc = 0;
        for (const key in details) {
            let amount = details[key].free == 1 ? 0 : (details[key].qty * details[key].price);
            subtotal += amount;
            amount_ppn += parseFloat(details[key].amount_ppn);
            amount_pph += parseFloat(details[key].amount_pph);
            amount_dpp += parseFloat(details[key].amount_dpp);
            amount_disc += parseFloat(details[key].amount_discount);
        }

        return { subtotal, amount_ppn, amount_pph, amount_dpp, amount_disc };
    }

    const CalculatePO = (details) => {
        let subtot = 0;
        let amount_ppn = 0;
        let amount_dpp = 0;
        let amount_disc = 0;
        for (const key in details) {
            let amount = (details[key].qty * details[key].price);
            subtot += amount;
            amount_ppn += parseFloat(details[key].amount_ppn);
            amount_dpp += parseFloat(details[key].amount_dpp);
            amount_disc += parseFloat(details[key].amount_discount);
        }

        return { subtot, amount_ppn, amount_dpp, amount_disc };
    }

    const propsPrint = { getState: state, getInfo: info, login: info.user_information, getStateIPG: stateIPG }
    const propsPrintPO = { getState: statePO, login: userInfo }
    const propsPrintDelivery = { getState: stateDelivery, login: userInfo }
    const propsPrintInventory = { getState: stateInventory, login: userInfo }



    return (
        <div class="container-xl px-4" style={{ padding: 10 }}>
            <Helmet>
                <title>More - EStatement</title>
                {/* <meta name="viewport" content="width=1024" /> */}
            </Helmet>
            <style>{pageStyle}</style>
            <div class="row justify-content-center">
                {modul == 'salesorder' &&
                    <PrintSO ref={componentRef} {...propsPrint} />
                }
                {modul == 'purchaseorder' &&
                    <PrintPO ref={componentRef} {...propsPrintPO} />
                }
                {modul == 'delivery' &&
                    <PrintDelivery ref={componentRef} {...propsPrintDelivery} />
                }
                {modul == 'inventory-receipt' &&
                    <PrintTransfer ref={componentRef} {...propsPrintInventory} />
                }
                {modul == 'ipg' &&
                    // <PrintIPG  ref={componentRef} {...propsPrint}/>
                    <PrintSO ref={componentRef} {...propsPrint} />
                }
            </div>
        </div>
    );
};

export default EStatement;
